import React from 'react';
import { Link } from 'react-router-dom';
import { PublicHeader, PublicFooter } from '../components/PublicLayout';
import { groupedDocs, DOCS } from '../docs/registry';
import usePageTitle from '../hooks/usePageTitle';
import useCanonical from '../hooks/useCanonical';

const BRAND_BLUE = '#2B4B6A';

const DocsIndex = () => {
  usePageTitle('Documentation | Trados');
  useCanonical('/docs');
  const groups = groupedDocs();

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <PublicHeader />
      <div className="flex-1 w-full max-w-6xl mx-auto px-6 py-12">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: BRAND_BLUE }}>
            Documentation
          </p>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900">How Trados works</h1>
          <p className="text-gray-600 mt-3">
            Everything the platform does, from claiming your company through verification, Letters of Intent and the
            API — {DOCS.length} pages across {groups.length} sections.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
          {groups.map(({ section, icon, pages }) => (
            <div key={section} className="rounded-2xl border border-gray-200 p-5 hover:shadow-md transition-shadow">
              <div className="flex items-center gap-2.5 mb-3">
                <span className="p-2 rounded-lg" style={{ background: `${BRAND_BLUE}12` }}>
                  <svg viewBox="0 0 24 24" fill="none" stroke={BRAND_BLUE} strokeWidth="2"
                       strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
                    <path d={icon} />
                  </svg>
                </span>
                <h2 className="font-semibold text-gray-900">{section}</h2>
              </div>
              <ul className="space-y-1.5">
                {pages.map((p) => (
                  <li key={p.slug}>
                    <Link to={`/docs/${p.slug}`} className="text-sm text-gray-600 hover:underline"
                          style={{ textDecorationColor: BRAND_BLUE }}>
                      {p.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <PublicFooter />
    </div>
  );
};

export default DocsIndex;
